import { connect } from "react-redux";

import BinaryQuestionsWrapper from "apps/questions/components/BinaryQuestionsWrapper";

function mapStateToProps(state) {
	return {
		question: state.questions.question,
	};
}

export default connect(
	mapStateToProps,
	null,
)(BinaryQuestionsWrapper);



// WEBPACK FOOTER //
// ./src/apps/questions/containers/BinaryQuestionsWrapper.js